import './ReferralItem.scss'

import _ from 'lodash'
import React from 'react'
import cx from 'bem-classnames'
import {
  SHORT_ASSIGNMENT_AGENT_STATUS,
  SHORT_ASSIGNMENT_AGENT_STATUS_LISTING,
  TRANSACTION_TYPE,
  SHORT_ASSIGNMENT_AGENT_STATUS_LEASE,
  DYNAMIC_PRICING_CATEGORY,
} from 'common/constants'
import { labelFor } from 'common/util/helper'
import HighlightText from 'common/views/atoms/HighlightText/HighlightText'
import { Button } from 'react-bootstrap'
import moment from 'moment-timezone'
import { Badges } from 'manager/views/components/Referral/Badges'


const onlyTransitionTag = _.memoize(tags => _.filter(tags, ({ type }) => type === DYNAMIC_PRICING_CATEGORY.TRANSITION))


export const ConfirmedClosedReferralItem = ({ item, onClick, search }) => {
  return (
    <div className="ReferralItem ReferralItem--confirmed_closed">
      <div className="ReferralItem--confirmed_closed__details">
        <div className="ReferralItem__name"><HighlightText search={search} text={item.name.match('Declined last name') ? item.name.split(' ')[0] : item.name}/></div>
        <div className="ReferralItem--confirmed_closed__details__info">
          <div>{ item.agent_close_amount_currency }</div>
        </div>
        {item.confirmed_closed_at ? <div className="ReferralItem--confirmed_closed__closed_at">{moment.utc(item.confirmed_closed_at).local().format('l LT')}</div> : null}
      </div>
      <div className="ReferralItem--confirmed_closed__add">
        {<Button bsStyle="success" onClick={() => onClick(item)}><i className="fa fa-plus" aria-hidden="true"></i><span>Open New Transaction</span></Button>}
      </div>
    </div>
  )
}


export const ReleasedReferralItem = ({ item, onClick, search, isRestored, restoring }) => {

  const isBeingRestored = restoring == item.hash

  return (
    <div className="ReferralItem ReferralItem--released">
      <div className="ReferralItem__released_details">
        <div className="ReferralItem__name"><HighlightText search={search} text={item.name.match('Declined last name') ? item.name.split(' ')[0] : item.name}/></div>
        <div className="ReferralItem__released_status">Released</div>
        {item.last_released_at ? <div className="ReferralItem__released_at">{moment.utc(item.last_released_at).local().format('l LT')}</div> : null}
      </div>
      <div className="ReferralItem__restore">
        {isRestored &&
          <Button bsStyle="success" disabled={true} ><i className="fa fa-check" aria-hidden="true"></i><span>Restored</span></Button>}
        {!isRestored && !isBeingRestored &&
          <Button bsStyle="success" disabled={!!restoring} onClick={() => onClick(item)}>
            <i className="fa fa-undo" aria-hidden="true"></i><span>Restore To Active</span>
          </Button>}
        {!isRestored && isBeingRestored &&
          <Button bsStyle="success" disabled={true} ><span>Restoring...</span></Button>}
      </div>
    </div>)
}


export const ReferralItem = ({ item, onClick, search }) => {

    const classes = {
      name: 'ReferralItem',
      modifiers: ['warning', 'danger', 'success', 'holding', 'desc']
    }

    let status
    let statusClassName = {}
    if (item.needs_urgent_action || item.no_agent_updates) {
      statusClassName = {danger: true}
      status =
        <div className="ReferralItem__notice">
          <i className="fa fa-exclamation-triangle" aria-hidden="true"></i><span>This referral needs an update</span>
        </div>
    } else if (item.needs_action) {
      statusClassName = {warning: true}
      status =
        <div className="ReferralItem__notice">
          <i className="fa fa-exclamation-triangle" aria-hidden="true"></i><span>This referral will need an update soon</span>
        </div>
    } else if (item.is_recently_updated) {
      statusClassName = {success: true}
      status =
        <div className="ReferralItem__notice">
          <i className="fa fa-check" aria-hidden="true"></i><span>This referral was recently updated</span>
        </div>
    }

    let holding
    if (item.is_holding) {
      statusClassName['holding'] = true
      holding = <div className="ReferralItem__holding">
        <i className="fa fa-clock-o" aria-hidden="true"></i><span>{ `Hold: ${item.agent_hold_until} remaining` }</span>
      </div>
    }

    let preapproved
    if (item.is_preapproved && !item.is_holding) {
      preapproved = <span className="ReferralItem__preapproved">
        <i className="fa fa-check" aria-hidden="true" /><span>Pre-Approved</span>
      </span>
    }

    const desc = (item.desc) ? " - " + item.desc : ""
    let transactionTypeDesc = <div className="ReferralItem__description">
      { labelFor(TRANSACTION_TYPE, item.transaction_type) }{ desc }
    </div>


    let pendingClosing
    if (item.agent_status === 'closed' && (!item.closing_stmt_received || !item.payment_received || (!item.full_payment_received && (!!item.overdue_paid_currency || !!item.overdue_balance_remaining_currency)))) {

      pendingClosing = <div className="ReferralItem__pending-closing">
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i><span>{ `Pending Closing Items` }</span>
      </div>

      // If pending closing - clear some other UI elements
      preapproved = null
      holding = null
    }

    let short_agent_status
    if(item.is_lease) {
      short_agent_status = labelFor(SHORT_ASSIGNMENT_AGENT_STATUS_LEASE, item.agent_status)
    } else {
      short_agent_status = item.transaction_type === 'list' ? labelFor(SHORT_ASSIGNMENT_AGENT_STATUS_LISTING, item.agent_status) : labelFor(SHORT_ASSIGNMENT_AGENT_STATUS, item.agent_status)
    }

    const name = item.transaction_name || item.name

    return (
      <div key={item.hash} className={"clickable " + cx(classes, statusClassName)} onClick={() => onClick(item)}>
        <div className="ReferralItem__name">
          <HighlightText search={search} text={ name.match('Declined last name') ? name.split(' ')[0] : name }/>
          <Badges className="ReferralItem__badges" tags={onlyTransitionTag(item.transaction_tags)} />
        </div>
        <div className="ReferralItem__details">
          <span className="ReferralItem__status">
            { short_agent_status }
          </span>
        </div>
        { transactionTypeDesc }
        <div>
          { preapproved }
        </div>
        { holding }
        { status }
        { pendingClosing }
        <i className="ReferralItem__indicator fa fa-chevron-right" aria-hidden="true"></i>
        <span className="ReferralItem__time-since">{ item.agent_last_update_at ? `Last Updated: ${item.agent_last_update_at}` : `Assigned: ${item.time_since}` }</span>
      </div>)
  }
